
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Button',
  props: {
    text: { type: String, default: 'Какой-то текст' },
    type: { type: String, default: '' }
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
});
